import { FaChartPie, FaBoxOpen, FaClipboardList, FaSignOutAlt, FaUsers } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MobileDashboardMenus = () => {
    const { t } = useTranslation();

    const navItems = [
        { label: 'Dashboard', to: '/dashboard', icon: FaChartPie, end: true },
        { label: 'Inventory', to: '/dashboard/products', icon: FaBoxOpen },
        { label: 'Sales', to: '/dashboard/orders', icon: FaClipboardList },
        { label: 'Customers', to: '/dashboard/customers', icon: FaUsers },
        { label: 'Logout', to: '/dashboard/logout', icon: FaSignOutAlt },
    ];

    return (
        <div className="md:hidden grid grid-cols-2 gap-4 mb-4 rounded-lg border border-slate-200 bg-white p-4 shadow-sm">
                        {navItems.map(({ label, to, icon: Icon, end }) => (
                            <div key={label}>
                                <NavLink
                                    to={to}
                                    end={end}
                                    className={({ isActive }) =>
                                        [
                                            'flex items-center gap-3 rounded-md px-3 py-3 text-sm font-semibold transition',
                                            isActive
                                                ? 'bg-[#00595A] text-white shadow-sm'
                                                : 'text-slate-600 hover:bg-slate-100 hover:text-[#00595A]',
                                        ].join(' ')
                                    }
                                >
                                    <Icon className="h-4 w-4 shrink-0" />
                                    <span>{t(`dashboard.common.${label.toLowerCase()}`) || label}</span>
                                </NavLink>
                            </div>
                        ))}
        </div>
    );
};

export default MobileDashboardMenus;
